module.exports = __webpack_public_path__ + "img/HTML5.50dfa526.png";